import React, { useState, useEffect } from 'react';
import '../pages/main.css';
import '../pages/nft.css';
import { Button, useNotification, Loading } from '@web3uikit/core';
import Footer from '../components/footer';
import Home from './nftHome';
import tg from '../images/telegram2.png';
import mail from '../images/email2.png';
import twitter from '../images/twitter2.png';
import navbar from '../images/navigation-bar.png';
import wrong from '../images/wrong.png';
import img1 from '../images/nft.jpeg';
import img2 from '../images/img1.jpeg';
import img3 from '../images/img2.jpeg';
import img4 from '../images/img3.jpeg';
import img5 from '../images/img4.jpeg';
import Process from '../components/process';
import FAQ from '../components/faq';
import Carousel from '../components/carousel';
import translate from '../images/translate.png';

var Scroll = require('react-scroll');

let signer;
var Link = Scroll.Link;
var DirectLink = Scroll.DirectLink;
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;

const NFT = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [paymentMade, setPaymentMade] = useState(false);
    const notification = useNotification();
    const [loading, setLoadingState] = useState(false);
    const [_isEligibleToDeploy, setIsEligibleToDeploy] = useState(false);
    const [_getLastPaymentRecordIndex, setLastPaymentRecordIndex] = useState();
    const [provider, setProvider] = useState(window.ethereum);
    const [_signerAddress, setSignerAddress] = useState();
    const [_navbarOpen, set_navbarOpen] = useState(0);

    const handlePaymentMade = () => {
        setPaymentMade(true);
    };

    async function closeNav() {
        set_navbarOpen(0);
        //this.setState({ _navbarOpen: 0 });
    }

    async function navbarOpen() {
        set_navbarOpen(1);
        //this.setState({ _navbarOpen: 0 });
    }

    return (
        <>
            <div class="allWrap">
                <div class="light">

                    <div class="cont2">
                        <div class="headers">

                            <div class="h1">
                                <div class="logoDiv">
                                    Tokeniza
                                </div>

                                <div class="connect">
                                    <div><Link activeClass="" id="fontSize" to="about" spy={true} smooth={true} duration={550}>ABOUT</Link></div>
                                    <div><Link activeClass="" id="fontSize" to="process" spy={true} smooth={true} duration={550}>PROCESS</Link></div>
                                    <div><Link activeClass="" id="fontSize" to="connect" spy={true} smooth={true} duration={550}>CONNECT</Link></div>
                                    <div><Link activeClass="" id="fontSize" to="faq" spy={true} smooth={true} duration={550}>FAQ</Link></div>
                                    <div id="fontSize" onClick={() => window.location.href = 'home-en'}>Token</div>

                                    <div class="connect2">
                                        <button class="connectBtn" onClick={() => window.location.href = 'nft-dashboard'}>DASHBOARD</button>
                                    </div>
                                </div>

                            </div>

                        </div>

                        {_navbarOpen < 1 ?
                            (<div class="miniBarMain">
                                <div class="logoDiv"><span class="dashH" onClick={() => window.location.href = 'nft'}>Tokeniza</span>
                                </div>

                                <div class="navbarMain"><img class="navbar" onClick={navbarOpen} src={navbar} /></div>
                            </div>) :
                            (<div class="miniBarMain">
                                <div class="logoDiv"><span class="dashH" onClick={() => window.location.href = 'nft'}>Tokeniza</span>
                                </div>

                                <div class="navbarMain"><img class="navbar" onClick={closeNav} src={wrong} /></div>
                            </div>)}

                        {_navbarOpen > 0 ?
                            (<div class="littleNav">
                                <div><Link activeClass="" id="fontSize" to="about" spy={true} smooth={true} duration={550}>ABOUT</Link></div>
                                <div><Link activeClass="" id="fontSize" to="process" spy={true} smooth={true} duration={550}>PROCESS</Link></div>
                                <div><Link activeClass="" id="fontSize" to="connect" spy={true} smooth={true} duration={550}>CONNECT</Link></div>
                                <div><Link activeClass="" id="fontSize" to="faq" spy={true} smooth={true} duration={550}>FAQ</Link></div>
                                <div id="fontSize" onClick={() => window.location.href = 'home-en'}>Token</div>

                                <div>
                                    <span class="connect2">
                                        <button class="connectBtn" onClick={() => window.location.href = 'nft-dashboard'}>DASHBOARD</button>
                                    </span>
                                </div>
                                <div class="socialIcon">
                                    <img src={twitter} />
                                    <img src={mail} />
                                    <img src={tg} />

                                </div>

                            </div>) : null}

                        <Element name="home">

                            <div className='nftMain'>
                                <div className='nftMainH'>True Tokenization Experts</div>
                                <div className='nftMainP'>We are tokenization experts committed to excellence and cutting-edge technology; we work with unwavering dedication to revolutionize the way assets are preserved and traded in Mexico and around the world. We offer a seamless and secure tokenization experience, empowering businesses.</div>
                                {/*<button class="nftBtn">Buy NFTs at Tokeniza</button>*/}
                                <div className='nftMainP'>Transform assets into digital opportunities through NFTs.</div>
                                <div className='nftMainP'>NFTs are part of the digital transformation and are revolutionizing the way assets are traded and preserved in Mexico and around the world.</div>
                                <div className='nftMainP'>Convert assets to NFTs with Tokenize and participate in the digital economy in a secure, transparent, and efficient way.</div>
                            </div>

                            <Carousel />

                        </Element>
                    </div>


                    <Element name="about">
                        <div className='forPC'>
                        <div class="aboutMain">

                            <div class="aboutT-2">Tokeniza NFT is a groundbreaking project offering a multitude of utilities to users:</div>

                            <div class="aboutMain2">

                                <img class="deploy" src={img2} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Digitization of assets: Convert physical assets into NFTs, ensuring authenticity and provenance.</div>
                                </div>

                            </div>

                            <div class="aboutMain2">


                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Rental marketplace: Lease out real-world assets as NFTs, enforced by smart contracts for compliance.</div>
                                </div>

                                <img class="deploy" src={img1} data-aos="zoom-in" data-aos-duration="500" />


                            </div>

                            <div class="aboutMain2">

                                <img class="deploy" src={img3} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Fractional ownership: Enable shared ownership of assets through tokenization.</div>
                                </div>

                            </div>


                            <div class="aboutMain2">


                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Gamification: Explore gamified experiences leveraging NFTs and assets.</div>
                                </div>
                                <img class="deploy" src={img4} data-aos="zoom-in" data-aos-duration="500" />

                            </div>
                            <div class="aboutMain2">

                                <img class="deploy" src={img5} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Intellectual property tokenization: Tokenize intellectual property rights for secure ownership and exchange.</div>
                                </div>

                            </div>


                        </div>
                        </div>

                        <div className='forMob'>
                        <div class="aboutMain">

                            <div class="aboutT-2">Tokeniza NFT is a groundbreaking project offering a multitude of utilities to users:</div>

                            <div class="aboutMain2">

                                <img class="deploy" src={img2} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Digitization of assets: Convert physical assets into NFTs, ensuring authenticity and provenance.</div>
                                </div>

                            </div>

                            <div class="aboutMain2">

                            <img class="deploy" src={img1} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Rental marketplace: Lease out real-world assets as NFTs, enforced by smart contracts for compliance.</div>
                                </div>



                            </div>

                            <div class="aboutMain2">

                                <img class="deploy" src={img3} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Fractional ownership: Enable shared ownership of assets through tokenization.</div>
                                </div>

                            </div>


                            <div class="aboutMain2">

                            <img class="deploy" src={img4} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Gamification: Explore gamified experiences leveraging NFTs and assets.</div>
                                </div>

                            </div>
                            <div class="aboutMain2">

                                <img class="deploy" src={img5} data-aos="zoom-in" data-aos-duration="500" />

                                <div class="about2" data-aos="fade" data-aos-duration="500">
                                    <div class="aboutT2-2">Intellectual property tokenization: Tokenize intellectual property rights for secure ownership and exchange.</div>
                                </div>

                            </div>


                        </div>
                        </div>
                    </Element>

                    <Element name="connect">
                        <Home />
                    </Element>

                    <Element name="process">
                        <Process />
                    </Element>

                    <Element name="faq">
                        <FAQ />
                    </Element>

                    <Footer />

                </div>

                <div className='stickyBtn'><img class="stickyBtn2" onClick={() => window.location.href = 'nft-sp'} src={translate} /></div>

            </div>

        </>
    );
};

export default NFT;
